import { render, staticRenderFns } from "./CieloOverlay.vue?vue&type=template&id=25de8805&scoped=true"
import script from "./CieloOverlay.vue?vue&type=script&lang=js"
export * from "./CieloOverlay.vue?vue&type=script&lang=js"
import style0 from "./CieloOverlay.vue?vue&type=style&index=0&id=25de8805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de8805",
  null
  
)

export default component.exports